import Decimal from 'decimal.js';

// Own constructor: high precision so that division never rounds in practice,
// and rounding is applied only by roundFinal to the sums shown on screen.
const Dec = Decimal.clone({ precision: 60, toExpNeg: -60, toExpPos: 60 });

const ROUNDING_MODES = {
  HALF_UP: Dec.ROUND_HALF_UP,
  HALF_EVEN: Dec.ROUND_HALF_EVEN,
  DOWN: Dec.ROUND_DOWN,
  UP: Dec.ROUND_UP,
};

export const D = (value) => new Dec(value);

export const roundFinal = (d, rounding = { scale: 2, mode: 'HALF_UP' }) =>
  D(d).toDecimalPlaces(rounding.scale, ROUNDING_MODES[rounding.mode] ?? Dec.ROUND_HALF_UP);

// Whole hryvnias for the screen, thousands separated by a space.
export const formatWholeUah = (d, mode = 'HALF_UP') =>
  roundFinal(d, { scale: 0, mode })
    .toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
